import React from 'react';
import { Search } from 'lucide-react';
import CustomSelect from '../../ui/CustomSelect';

interface DocumentSearchFiltersProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  filterType: string;
  setFilterType: (value: string) => void;
  filterStatus: string;
  setFilterStatus: (value: string) => void;
}

const documentTypeOptions = [
  { value: 'all', label: 'Semua Jenis' },
  { value: 'ktp', label: 'KTP' },
  { value: 'kk', label: 'Kartu Keluarga' },
  { value: 'npwp', label: 'NPWP' },
  { value: 'slip_gaji', label: 'Slip Gaji' },
  { value: 'rekening_koran', label: 'Rekening Koran' },
  { value: 'sertifikat', label: 'Sertifikat' },
  { value: 'bpkb', label: 'BPKB' },
  { value: 'akta_nikah', label: 'Akta Nikah' },
  { value: 'surat_keterangan_usaha', label: 'Surat Keterangan Usaha' },
  { value: 'laporan_keuangan', label: 'Laporan Keuangan' },
  { value: 'slik', label: 'SLIK' },
  { value: 'foto', label: 'Foto' },
  { value: 'other', label: 'Lainnya' },
];

const statusOptions = [
  { value: 'all', label: 'Semua Status' },
  { value: 'valid', label: 'Valid' },
  { value: 'expired', label: 'Kadaluarsa' },
  { value: 'pending_verification', label: 'Pending' },
];

export default function DocumentSearchFilters({
  searchTerm,
  setSearchTerm,
  filterType,
  setFilterType,
  filterStatus,
  setFilterStatus,
}: DocumentSearchFiltersProps) {
  return (
    <div className="bg-white rounded-lg border shadow-sm p-4">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder="Cari nama debitur, CIF, nama dokumen, atau nomor dokumen..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none"
          />
        </div>
        <CustomSelect
          value={filterType}
          onChange={setFilterType}
          options={documentTypeOptions}
          placeholder="Jenis Dokumen"
          width="w-full md:w-48"
        />
        <CustomSelect
          value={filterStatus}
          onChange={setFilterStatus}
          options={statusOptions}
          placeholder="Status"
          width="w-full md:w-40"
        />
      </div>
    </div>
  );
}
